import * as $ from 'jquery';
import * as SVG from 'svg.js';

/**
 * ANIMATION LIBRARAY for DFG Project Historical Art of Projection (eLaterna)
 * Version: 1.0.0
 *
 * @author Sheng, Li <sheng@uni-trier.de>
 */

class PKAnimation {

  public framesMaker: FramesMaker | undefined = undefined;

  constructor() {
    // create a new instance
  }
  
  public EventDispatcher(obj: FramesMaker) {
    obj.listeners = null;
    obj.captureListeners = null;
  }
}

class Rectangle {

  public x = 0;
  public y = 0;
  public width = 0;
  public height = 0;
  
  constructor(x: number, y: number, w: number, h: number) {
    this.setValue(x, y, w, h);
  }

  public setValue(x: number, y: number, w: number, h: number) {
    this.x = x;
    this.y = y;
    this.width = w;
    this.height = h;
  }
}

class FramesMaker {

  public listeners;
  public captureListeners;

  public image;
  public mask;
  public pictures;
  public loadCount = 0;
  public complete = false;
  public animationState = {
    isForward: true,
    isRunning: false,
    currentPictureNumber: 0,
    currentStepNumber: 0,
    currentFrameNumber: <any> -1,
    currentWaitTime: 25,
    stepSliceInfos: <any> [],  // time: number, opacity: number, angle: 0,
    totalDuration: 0, // total time of animations
    frameInfos: <any> []
  };
  
  public pictureWidth = 0;
  public pictureHeight = 0;
  public shrinkFactor = 1;
  public spacing = 0;
  public margin = 0;
  public regX = 0;
  public regY = 0;
  public numPictures = 0;
  public animationInProcessing;
  public animationStatecurrentFrameNumberWatchList: any[] = [];

  constructor(public canvas, public data) {
    this.parseData(data);
    this.initWatch();
  }

  public parseData(data) {
    // parse image:
    let img = data.image;
    if (typeof img === 'string') {
      const src = img;
      img = document.createElement('img');
      img.src = src;
    }
    this.image = img;
  
    // parse mask:
    let mask = data.mask;
    if (typeof mask === 'string') {
      const masksrc = mask;
      mask = document.createElement('img');
      mask.src = masksrc;
    }
    this.mask = mask;

    // parse pictures:
    this.shrinkFactor = 1.0 * this.canvas.height() / data.pictures.height;
    this.pictureWidth = data.pictures.width;
    this.pictureHeight = data.pictures.height;
    this.spacing = data.pictures.spacing ? data.pictures.spacing : 0;
    this.margin = data.pictures.margin ? data.pictures.margin : 0;
    this.regX = data.pictures.regX ? data.pictures.regX : 0;
    this.regY = data.pictures.regY ? data.pictures.regY : 0;

    const canvas = this.canvas[0];
    const ctx = canvas.getContext('2d');
    // ctx.scale(this.shrinkFactor, this.shrinkFactor);

    if (!img.getContext || !img.complete) {
      this.loadCount++;
      this.complete = false;
      img.onload = () => {
        this.handleImageLoading('image');
      };
    }
  }

  public loadPictures() {
    this.pictures = [];
    const maxPictures = 1000000;
    let frameCount = 0; 
    
    const img = this.image;
    const imgW = img.width;
    const imgH = img.height;

    const spacing = this.spacing;
    const margin = this.margin;

    // console.log(this.pictureHeight);
    // console.log(this.pictureWidth);
    // console.log(imgH);
    // console.log(imgW);

    const frameWidth = this.pictureWidth;
    const frameHeight = this.pictureHeight;

    let y = margin;
    calculatePictures:
    while (y <= imgH - margin - frameHeight) {
      let x = margin;
      while (x <= imgW - margin - frameWidth) {
        if (frameCount >= maxPictures) { break calculatePictures; }
        frameCount++;
        this.pictures.push({
          image: img,
          rect: new Rectangle(x, y, frameWidth, frameHeight),
          regX: this.regX,
          regY: this.regY
        });
        x += frameWidth + spacing;
      }
      y += frameHeight + spacing;
    }
    this.numPictures = frameCount;
  }

  public clearScreen() {
    const canvas = this.canvas[0];
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  public drawFrame(options, clearScreen) {
    const pictureNumber = options.pictureNumber;
    const useMask = options.useMask;
    const alpha = options.opacity;
    const angle = options.angle;
    const scale = options.scale;
    const offsetX = options.offsetX;
    const offsetY = options.offsetY;
    if (this.pictures && this.pictures.length > 0) {
      const canvas = this.canvas[0]; // jquery object to dom object
      const ctx = canvas.getContext('2d');
      const frameInfo = this.pictures[pictureNumber];
      const rect = frameInfo.rect;
      let picW = rect.width;
      let picH = rect.height;
      let drawX = -frameInfo.regX;
      let drawY = -frameInfo.regY;
      let drawW = rect.width;
      let drawH = rect.height;
      if (clearScreen) {
        this.clearScreen();
      }
  
      // setup draw settings
      ctx.globalAlpha = alpha;
      if (scale !== 1 || angle !== 0) {
        ctx.translate(canvas.width / 2, canvas.height / 2);
        drawX = -rect.width / 2;
        drawY = -rect.height / 2;
      } 
      if (scale !== 1) {
        ctx.scale(scale, scale);
      } 
      if (angle !== 0) {
        ctx.rotate(angle * Math.PI / 180);
      } 
      if (offsetX !== 0) {
        drawX += offsetX;
        picW = this.image.width;
        picH = this.image.height;
        drawW = picW;
        drawH = picH;
      }
      if (offsetY !== 0) {
        drawY += offsetY;
      }
      
      // draw
      ctx.drawImage(frameInfo.image, 
        rect.x, rect.y, picW, picH, 
        drawX, drawY, drawW * this.shrinkFactor, drawH * this.shrinkFactor);
  
      // setup draw settings back
      if (angle !== 0) {
        ctx.rotate(-angle * Math.PI / 180);
      } 
      if (scale !== 1) {
        ctx.scale(1.0 / scale, 1.0 / scale);
      } 
      if (scale !== 1 || angle !== 0) {
        ctx.translate(-canvas.width / 2, -canvas.height / 2);
      } 
  
      // draw mask
      if (useMask) {
        ctx.drawImage(this.mask, 
          0, 0);
      }
    }
  }

  public drawFrameByFrameNumber(num) {
    const fi = this.animationState.frameInfos[num];
    const sd = this.animationState.stepSliceInfos[fi.stepNum].slices[fi.sliceNum].sliceDrawing;
    for (let i = 0; i < sd.length; i ++) {  
      let clearScreen = false;
      if (i === 0) {
        clearScreen = true;
      }
      this.drawFrame(sd[i], clearScreen);
    }
  }

  /**
   * StepSliceInfos: [
   *     {
   *       totalDuration: number, // ms
   *       slices: [
   *         {
   *           time: number, // ms
   *           sliceDrawing: [ // which pictures in which form on canvas
   *             {
   *               pictureNumber: number,
   *               opacity: number,
   *               angle: number,
   *               scale: number,
   *               offsetX: number,
   *               offsetY: number
   *             },
   *             ...
   *           ]
   *         },
   *         ...
   *       ]
   *     },
   *     ...
   * ],
   * frameInfos: [
   *     {
   *       stepNum: number,
   *       sliceNum: number
   *     }
   * ]
   * 
   */
  public calculateStepSliceInfos() {
    const fm = this;
    const steps = fm.data.steps;
    fm.animationState.stepSliceInfos = [];
    const ssi = fm.animationState.stepSliceInfos;
    
    let accuTime = 0; // accumulative time
  
    const sliceFactory = () => {
      const s = {
        time: 0,
        sliceDrawing: <any> []
      };
      return s;
    };
    const sliceDrawingFactory = (fn) => {
      const sd = {
        useMask: false,
        angle: 0,
        opacity: 1,
        scale: 1,
        offsetX: 0,
        offsetY: 0,
        pictureNumber: fn
      };
      return sd;
    };
    for (let i = 0; i < steps.length; i++) {
      const step = steps[i];
      if (step.effect === 'classic-animation') {
        step.duration = 1.0 * (step.endFrame - step.startFrame + 1) / step.framerate;
      }
      const stepSliceInfo = {
        totalDuration: step.duration * 1000,
        slices: <any> []
      };
      fm.animationState.totalDuration += stepSliceInfo.totalDuration + step.lastStepGap * 1000;
      accuTime += step.lastStepGap * 1000;
      if (step.effect === 'cross-fade') {
        
        const sframerate = step.framerate;
        const fadeoutPicture = step.fadeoutPicture;
        const fadeoutAngle = step.fadeoutAngle;
        const fadeinPicture = step.fadeinPicture;
        const fadeinAngle = step.fadeinAngle;
        const sduration = step.duration;
        const fadeoutStartTime = step.fadeoutStartTime;
        const fadeoutEndTime = step.fadeoutEndTime;
        const fadeinStartTime = step.fadeinStartTime;
        const fadeinEndTime = step.fadeinEndTime;
  
        const msPerSlice = 1000 / sframerate;
        if (fadeoutEndTime > sduration || fadeinEndTime > sduration) {
          throw new Error('Error: Step ' + i + ' -- fadeoutEndTime or fadeinEndTime bigger than duration');
        }
  
        // calculate time and sliceDrawing for every slices
        const sliceCount = stepSliceInfo.totalDuration / msPerSlice;
  
        // fade-out and fade-in period
        const fadeoutStartTimeMS = fadeoutStartTime * 1000 + accuTime;
        const fadeoutEndTimeMS = fadeoutEndTime * 1000 + accuTime;
        const fadeinStartTimeMS = fadeinStartTime * 1000 + accuTime;
        const fadeinEndTimeMS = fadeinEndTime * 1000 + accuTime;
        const fadeoutDelta = 1.0 / ((fadeoutEndTimeMS - fadeoutStartTimeMS) / (1000 / sframerate));
        let fadeoutOpacity = 1;
        const fadeinDelta = 1.0 / ((fadeinEndTimeMS - fadeinStartTimeMS) /  (1000 / sframerate));
        let fadeinOpacity = 0;
  
        for (let sc = 0; sc < sliceCount; sc ++) {
          const slice = sliceFactory();
          slice.time = accuTime;
          if (accuTime >= fadeoutStartTimeMS && accuTime <= fadeoutEndTimeMS) {
            // fadeout phase
            fadeoutOpacity -= fadeoutDelta;
            if (fadeoutOpacity < 0) {
              fadeoutOpacity = 0;
            }
            const sldFO = sliceDrawingFactory(fadeoutPicture);
            sldFO.opacity = fadeoutOpacity;
            sldFO.angle = fadeoutAngle;
            slice.sliceDrawing.push(sldFO);
          }
          if (accuTime >= fadeinStartTimeMS && accuTime <= fadeinEndTimeMS) {
            // fadeinDelta phase
            fadeinOpacity += fadeinDelta;
            if (fadeinOpacity > 1) {
              fadeinOpacity = 1;
            }
            const sldFI = sliceDrawingFactory(fadeinPicture);
            sldFI.opacity = fadeinOpacity;
            sldFI.angle = fadeinAngle;
            slice.sliceDrawing.push(sldFI);
          }
          stepSliceInfo.slices.push(slice);
          accuTime += msPerSlice;
        }
      } else if (step.effect === 'rotation') {
        const sframerate = step.framerate;
        const rotationPicture = step.rotationPicture;
        const startAngle = step.startAngle;
        const endAngle = step.endAngle;
        const sduration = step.duration;
  
        const msPerSlice = 1000 / sframerate;
  
        // calculate time and sliceDrawing for every slices
        const sliceCount = stepSliceInfo.totalDuration / msPerSlice;
  
        // rotation delta
        const rotationDelta = (endAngle - startAngle) / sliceCount;
        let accuAngle = startAngle + rotationDelta;
        for (let sc = 0; sc < sliceCount; sc ++) {
          const slice = sliceFactory();
          slice.time = accuTime;
          const sldRO = sliceDrawingFactory(rotationPicture);
          sldRO.angle = accuAngle;
          slice.sliceDrawing.push(sldRO);
          
          stepSliceInfo.slices.push(slice);
          accuTime += msPerSlice;
          accuAngle += rotationDelta;
          if ((accuAngle > endAngle && endAngle > 0) || 
            (accuAngle < endAngle && endAngle < 0)) {
            accuAngle = endAngle;
            }
        }
      } else if (step.effect === 'zoom') {
        const sframerate = step.framerate;
        const zoomPicture = step.zoomPicture;
        const startZoomFactor = step.startZoomFactor;
        const endZoomFactor = step.endZoomFactor;
        const sduration = step.duration;
  
        const msPerSlice = 1000 / sframerate;
  
        // calculate time and sliceDrawing for every slices
        const sliceCount = stepSliceInfo.totalDuration / msPerSlice;
  
        // zoom delta
        const zoomDelta = (endZoomFactor - startZoomFactor) / sliceCount;
        let accuZoom = startZoomFactor;
        for (let sc = 0; sc < sliceCount; sc ++) {
          const slice = sliceFactory();
          slice.time = accuTime;
          const sldRO = sliceDrawingFactory(zoomPicture);
          sldRO.scale = accuZoom;
          slice.sliceDrawing.push(sldRO);
          
          stepSliceInfo.slices.push(slice);
          accuTime += msPerSlice;
          accuZoom += zoomDelta;
          if ((zoomDelta >= 0 && accuZoom > endZoomFactor) || // zoom in 
            (zoomDelta < 0 && accuZoom < endZoomFactor) // zoom out 
          ) {
            accuZoom = endZoomFactor;
          }
          
        }
      } else if (step.effect === 'move') {
        const sframerate = step.framerate;
        const movePicture = step.movePicture;
        const offsetX = step.offsetX;
        const offsetY = step.offsetY;
        const scale = step.scale;
        const sduration = step.duration;
        const useMask = step.useMask ? true : false;
  
        const msPerSlice = 1000 / sframerate;
  
        // calculate time and sliceDrawing for every slices
        const sliceCount = stepSliceInfo.totalDuration / msPerSlice;
  
        // move delta
        const moveDeltaX = (offsetX - 0) / sliceCount;
        const moveDeltaY = (offsetY - 0) / sliceCount;
        let accuMoveX = 0;
        let accuMoveY = 0;
        for (let sc = 0; sc < sliceCount; sc ++) {
          const slice = sliceFactory();
          slice.time = accuTime;
          const sldMV = sliceDrawingFactory(movePicture);
          sldMV.useMask = useMask;
          sldMV.offsetX = accuMoveX;
          sldMV.offsetY = accuMoveY;
          sldMV.scale = scale;
          slice.sliceDrawing.push(sldMV);
          stepSliceInfo.slices.push(slice);
          accuTime += msPerSlice;
          accuMoveX += moveDeltaX;
          accuMoveY += moveDeltaY;
          
        }
      } else if (step.effect === 'classic-animation') {
        const sframerate = step.framerate;
        const startFrame = step.startFrame;
        const endFrame = step.endFrame;
        const sduration = 1.0 * (endFrame - startFrame + 1) / sframerate;
        const useMask = step.useMask ? true : false;
  
        const msPerSlice = 1000 / sframerate;
  
        // calculate time and sliceDrawing for every slices
        const sliceCount = (endFrame - startFrame + 1);
  
        for (let sc = 0; sc < sliceCount; sc ++) {
          const slice = sliceFactory();
          slice.time = accuTime;
          const pictureNumber = startFrame + sc;
          const sldMV = sliceDrawingFactory(pictureNumber);
          sldMV.useMask = useMask;
          slice.sliceDrawing.push(sldMV);
          stepSliceInfo.slices.push(slice);
          accuTime += msPerSlice;
          
        }
      }
  
      ssi.push(stepSliceInfo);
    }
  }

  public calculateFrameInfos() {
    const fm = this;
    const ssi = fm.animationState.stepSliceInfos;
    fm.animationState.frameInfos = [];
    const fi = fm.animationState.frameInfos;
  
    for (let i = 0; i < ssi.length; i++) {
      for (let j = 0; j < ssi[i].slices.length; j++) {
        fi.push({
          stepNum: i,
          sliceNum: j});
        // for (let k = 0; k < ssi[i].slices[j].sliceDrawing.length; k++) {
        // }
      }
    }
  
    // sort fi
    const compare = (a, b) => {
      if (ssi[a.stepNum].slices[a.sliceNum].time < 
        ssi[b.stepNum].slices[b.sliceNum].time) {
        return -1;
      } else {
        return 1;
      }
    };
    fi.sort(compare); 
  
    // if (logMsgEnable) 
    //   console.log('totalFrames: ' + fm.animationState.frameInfos.length + ' ');
  
    // // log the time series frames info
    // // for (let i = 0; i < fi.length; i++) {
    // //   if (i === 192 || i === 191){
    // //     logMsgEnable ? console.log(ssi[fi[i].stepNum].slices[fi[i].sliceNum].time): null;
    // //     let sd =  ssi[fi[i].stepNum].slices[fi[i].sliceNum].sliceDrawing;
    // //     for (let j = 0; j < sd.length; j++) {
    // //       logMsgEnable ? console.log(sd[j].pictureNumber + ' ' + sd[j].opacity): null;
    // //     }
    // //   }
    // // }
  }

  public recompileSteps(steps?) {
    if (steps) {
      this.data.steps = steps;
    }
    this.animationState.totalDuration = 0;
    this.calculateStepSliceInfos();
    this.calculateFrameInfos();
    // show first frame
    this.animationState.currentFrameNumber = 0;
    // set frame to -1
    this.animationState.currentFrameNumber = -1;
  }

  public animate() {
    const fm = this;
    const animationState = fm.animationState;
    const asSSI = animationState.stepSliceInfos;
    const asFI = animationState.frameInfos;
    const totalFrameNum = asFI.length;
    let currNum = 0;
    let nextNum = 0;
    const repeatDrawFrames = () => {
      if (animationState.currentFrameNumber >= -1 && 
        animationState.currentFrameNumber <= totalFrameNum && 
        animationState.isRunning) {
        if (animationState.isForward) {
          if (animationState.currentFrameNumber >= totalFrameNum - 1) {
            animationState.currentFrameNumber = totalFrameNum;
            fm.stopAnimation();
            return;
          }
          animationState.currentFrameNumber += 1;
          nextNum = animationState.currentFrameNumber + 1;
          currNum = animationState.currentFrameNumber;
          if (nextNum === totalFrameNum) {
            animationState.currentFrameNumber = totalFrameNum;
            fm.stopAnimation();
            return;
          }
        } else {
          if (animationState.currentFrameNumber <= 0) {
            animationState.currentFrameNumber = -1;
            fm.stopAnimation();
            return;
          }
          animationState.currentFrameNumber -= 1;
          nextNum = animationState.currentFrameNumber - 1;
          currNum = animationState.currentFrameNumber;
          if (nextNum < 0) {
            animationState.currentFrameNumber = -1;
            fm.stopAnimation();
            return;
          }
        }
  
        if (currNum !== -1 && currNum !== totalFrameNum) {
          const sliceDrawing = asSSI[asFI[currNum].stepNum]
            .slices[asFI[currNum].sliceNum]
            .sliceDrawing;
          animationState.currentPictureNumber = sliceDrawing.frameNumber;
          animationState.currentStepNumber = asFI[currNum].stepNum;
          const nextTimePoint = asSSI[asFI[nextNum].stepNum]
            .slices[asFI[nextNum].sliceNum].time;
          const currTimePoint = asSSI[asFI[currNum].stepNum]
            .slices[asFI[currNum].sliceNum].time;
          fm.animationState.currentWaitTime = Math.abs(nextTimePoint - currTimePoint);
        }
        clearInterval(fm.animationInProcessing);
        fm.animationInProcessing = setInterval(repeatDrawFrames, fm.animationState.currentWaitTime);
      } else {
        fm.stopAnimation();
      }
  
    };
    repeatDrawFrames();
    
  }

  public stopAnimation() {
    clearInterval(this.animationInProcessing);
    this.animationState.isRunning = false;
  }

  public pause() {
    const fm = this;
    fm.stopAnimation();
  }
  public forward() {
    const fm = this;
    fm.stopAnimation();
    fm.animationState.isRunning = true;
    fm.animationState.isForward = true;
    fm.animate();
  }

  public backward() {
    const fm = this;
    fm.stopAnimation();
    fm.animationState.isRunning = true;
    fm.animationState.isForward = false;
    fm.animate();
  }

  public resume() {
    const fm = this;
    fm.animationState.isRunning = true;
    fm.animate();
  }

  public handleImageLoading(s) {
    this.loadCount--;
    if (this.loadCount === 0) {
      if (s === 'image') {
        this.loadPictures();
      }
      // this.loadPictures();
      this.complete = true;
      // this.dispatchEvent('complete');
    }
  }
  public addAnimationStateWatch(prop, func) {
    if (prop === 'currentFrameNumber') {
      this.animationStatecurrentFrameNumberWatchList.push(func);
    }
  }

  public initWatch() {
    const fm = this;
    // this.animationState.watch('currentFrameNumber', (prop, oldVal, newVal) => {
    //   for (const f in fm.animationStatecurrentFrameNumberWatchList) {
    //     if (fm.animationStatecurrentFrameNumberWatchList[f]) {
    //       fm.animationStatecurrentFrameNumberWatchList[f](prop, oldVal, newVal);
    //     }
    //   }
    // });
    this.animationState = new Proxy(this.animationState, {
      set: (obj, prop, value) => {
        if (prop === 'currentFrameNumber') {
          const oldVal = obj.currentFrameNumber;
          for (const f in fm.animationStatecurrentFrameNumberWatchList) {
            if (fm.animationStatecurrentFrameNumberWatchList[f]) {
              fm.animationStatecurrentFrameNumberWatchList[f](prop, oldVal, value);
            }
          }
        }
        obj[prop] = value;
        return true;
      },
    });
    // using currentFrameNumber to trigger animation 
    this.addAnimationStateWatch('currentFrameNumber', (prop, oldVal, newVal) => {
      if (newVal !== -1 && newVal !== fm.animationState.frameInfos.length) {
        fm.drawFrameByFrameNumber(newVal);
      }
    });
  }

}


/**
 * PKAnimationFrameCreator
 *
 *   All effects are based on steps. 
 *
 */
export class PKAnimationFrameCreator {

  public fm: FramesMaker; 

  public canvasWidth;
  public canvasHeight;
  public effects;

  public backgroundButtonImageSize;
  public paused;

  public stepName;
  public stepNameSpan;
  
  public pkaShowBar;
  public showBarInfo;
  public showBarDrawarea;
  public showBarBar;

  public showSettings;
  public pkaSettingShowBtn;
  public pkaSettingPlainText;
  public pkaSettingCompileBtn;
  public pkaSettingPanel;

  public pkaFrame;
  public pkaCanvas;
  public pkaControlDiv;
  public pkaControlPanel;
  public pkaSliderBar;
  public pkaSliderBlock;
  public pkaControlButtonPanel;
  public pkaBackwardButton;
  public pkaPauseContiButton;
  public pkaForwardButton;

  constructor(public pkaFrameId, public picturesData) {
    this.backgroundButtonImageSize = 24;
    this.picturesData = picturesData;
    
    // ----------
    // create ui
    // ----------

    // frame
    this.pkaFrame = $('<div class="pkaFrame PKAnimationVertical"></div>')
    .prop('title', picturesData.description);
    $('#' + this.pkaFrameId).append(this.pkaFrame);
    // calculate canvas size
    const cW = <number> $('#' + this.pkaFrameId).parent().width();
    let cH = <number> $('#' + this.pkaFrameId).parent().height();
    let extraHeight = 115; // height of controls and others
    this.canvasHeight = picturesData.pictures.height;
    if (this.canvasHeight > picturesData.pictures.height) {
      this.canvasHeight = picturesData.pictures.height;
    }
    this.canvasWidth = this.canvasHeight;

    this.pkaCanvas = $('<canvas class="pkaCanvas" width="' + this.canvasWidth + '" height="' + this.canvasHeight + '"></canvas>');

    this.pkaFrame.append(this.pkaCanvas);
    this.pkaFrame.width(this.canvasWidth);

    // show config error
    if (picturesData.error) {
      const ctx2d = this.pkaCanvas[0].getContext('2d');
      ctx2d.font = '20px Georgia';
      ctx2d.fillStyle = 'white';
      ctx2d.fillText('Animation Config Error detected', 10, 40);
      ctx2d.fillText('Please check it in FuD', 10, 80);
      ctx2d.font = '14px Georgia';
      ctx2d.fillText(picturesData.error, 10, 120);
      ctx2d.fillStyle = ctx2d.fillStyle;
    } else {
      // show 'loading'
      const canvas = this.pkaCanvas[0];
      // $(canvas).css('background-color', 'black');
      const ctx = canvas.getContext('2d');
      ctx.font = '30px Georgia';
      const ctxFs = ctx.fillStyle;
      ctx.fillStyle = 'white';
      ctx.fillText('Loading...', 10, 40);
      ctx.fillStyle = ctxFs;
    }

    // setup animation using animation data
    this.fm = new FramesMaker(this.pkaCanvas, this.picturesData);

    const adjustContainerAndFooter = (toExtraHeight) => {
      const oriCH = cH;
      if (cH < this.canvasHeight + toExtraHeight) {
        cH = this.canvasHeight + toExtraHeight;
        $('#' + this.pkaFrameId).parent().height(cH);
        const cHdiff = cH - oriCH;
        picturesData.cHdiff = cHdiff;
        // check if need to adjust position of footer
        const footerOffset = <$.Coordinates> $('.pk-footer').offset();
        picturesData.oriFooterTop = footerOffset.top;
        if (footerOffset.top < (<$.Coordinates> $('#' + this.pkaFrameId).offset()).top + cH) {
          $('.pk-footer').offset({
            top: (<$.Coordinates> $('.pk-footer').offset()).top + cHdiff,
            left: 0
          });
        }
      }
    };

    // setup overview canvas
    if (picturesData.overview && picturesData.overview.src) {
      const ovPic = document.createElement('img');
      ovPic.src = picturesData.overview.src;

      this.pkaFrame.append($(ovPic).css({
        'max-width': cW + 'px',
        'max-height': '100px',
        'margin': '0 auto'
      }).on('load', () => {
        let ovPicW = $(ovPic).width();
        ovPicW = ovPicW ? ovPicW : 0;
        $(ovPic).css({
          'margin-left': ((this.pkaFrame.width() - ovPicW) / 2) + 'px'
        });
        // adjust parent div
        extraHeight += <number> $(ovPic).height();
        adjustContainerAndFooter(extraHeight);
      }));

    } else {
      adjustContainerAndFooter(extraHeight);
    }

    // step name 
    this.stepName = $('<div class="pkaStepName PKAnimationVertical"></div>');
    this.stepNameSpan = $('<span class="pkaStepNameSpan"></span>');


    this.stepName.append(this.stepNameSpan);
    this.pkaFrame.append(this.stepName);

    // setup show bar
    this.pkaShowBar = $('<div id="pkaShowBarDiv" class="PKAnimationVertical"></div>');
    this.showBarInfo = {
      width: this.canvasWidth,
      height: 25,

    };
    this.pkaFrame.append(this.pkaShowBar);

    // control buttons
    this.pkaControlDiv = $('<div class="pkaControlDiv PKAnimationVertical"></div>');
    this.pkaControlPanel = $('<div class="pkaControlPanel PKAnimationVertical"></div>');
    this.pkaControlDiv.append(this.pkaControlPanel);
    this.pkaControlButtonPanel = $('<div class="pkaControlButtonPanel PKAnimationVertical"/>'); 
    this.pkaBackwardButton = $('<div class="pkaBackwardButton pkaControlButton"/>'); 
    this.pkaPauseContiButton = $('<div class="pkaPauseContiButton pkaControlButton pkaPauseContiButtonPause"/>');
    this.pkaPauseContiButton.css('margin-left', ((this.canvasWidth - this.backgroundButtonImageSize) / 2) + 'px');
    this.pkaForwardButton = $('<div class="pkaForwardButton pkaControlButton"/>');
    this.pkaForwardButton.css('margin-left', ((this.canvasWidth - this.backgroundButtonImageSize)) + 'px');
    // this.pkaControlPanel.append(this.pkaSliderBar);
    this.pkaControlButtonPanel.append(this.pkaBackwardButton);
    this.pkaControlButtonPanel.append(this.pkaPauseContiButton);
    this.pkaControlButtonPanel.append(this.pkaForwardButton);
    this.pkaControlPanel.append(this.pkaControlButtonPanel);

    this.pkaFrame.append(this.pkaControlDiv);

    // show settings
    this.showSettings = false;
    if (this.showSettings) {
        
      this.pkaSettingPanel = $('<div class="pkaSettingPanel row"></div>');
      this.pkaControlDiv.append(this.pkaSettingPanel);
      this.pkaSettingShowBtn = $('<input type="button" class="btn-primary col-sm-3" value="show settings"></input>');
      let settingShowed = false;
      this.pkaSettingShowBtn.click(() => { 
        if (settingShowed) {
          settingShowed = false;
          this.pkaSettingPlainText.hide();
          $(this).val('show settings');
        } else {
          settingShowed = true;
          this.pkaSettingPlainText.show();
          $(this).val('hide settings');
        
        }
      });
      this.pkaSettingPanel.append(this.pkaSettingShowBtn);
      this.pkaSettingCompileBtn = $('<input type="button" class="btn-primary col-sm-3 col-sm-offset-6" value="compile settings"></input>');
      this.pkaSettingCompileBtn.click(() => { 
        const steps = JSON.parse(this.pkaSettingPlainText.val());
        this.fm.recompileSteps(steps);
        this.initShowBar();
      });
      this.pkaSettingPanel.append(this.pkaSettingCompileBtn);
      this.pkaSettingPlainText = $('<textarea class="col-sm-12"></textarea>');
      this.pkaSettingPlainText.height(150);
      this.pkaSettingPanel.append(this.pkaSettingPlainText);
      this.pkaSettingPlainText.val(JSON.stringify(this.fm.data.steps, null, 5));
      this.pkaSettingPlainText.hide();
  
    }

    this.pkaBackwardButton.click(() => this.backwardAnimation());
    this.pkaPauseContiButton.click(() => this.pauseContiAnimation());
    this.pkaForwardButton.click(() => this.forwardAnimation());
    
    
    this.fm.recompileSteps();

    // wait until images loaded and intern data initialized
    this.waitLoading();
    
  }

  public setPkaFrameId(pkaFrameId) {
    this.pkaFrameId = pkaFrameId;
  }

  public initShowBar() {
    const showBarW = this.showBarInfo.width;
    const showBarH = this.showBarInfo.height;
    $('#pkaShowBar_drawarea').remove();
    this.showBarDrawarea = SVG('pkaShowBarDiv').size(showBarW, showBarH)
      .attr('id', 'pkaShowBar_drawarea')
      .addClass('pkaShowBar');
    const draw = this.showBarDrawarea;
    this.showBarBar = draw.rect(1, showBarH)
      .addClass('pkaShowBarBar');
    const fm = this.fm;
    const sliceCount = fm.animationState.frameInfos.length;

    $('#pkaShowBar_drawarea').click((evt) => {
      fm.stopAnimation();
      this.pkaPauseContiButton.removeClass('pkaPauseContiButtonPause');
      this.pkaPauseContiButton.removeClass('pkaPauseContiButtonContinue');
      this.pkaPauseContiButton.addClass('pkaPauseContiButtonPause');
      // for chrome and firefox
      // screenX is the x from leftest monitor
      // console.log(navigator.platform);
      // console.log(evt);
      // console.log(evt.clientX);
      // console.log(evt.pageX);
      // console.log(evt.screenX);
      // console.log(evt.offsetX);
      // console.log(evt.currentTarget.getBoundingClientRect().left);
      const px = evt.clientX ? evt.clientX - evt.currentTarget.getBoundingClientRect().left : 0;

      // console.log(sliceNum);
      const sliceNum = Math.floor(1.0 * px / showBarW * sliceCount);
      fm.animationState.currentFrameNumber = sliceNum;
    });

    // steps rects
    const effectRectConfig = [
      {
        effect: 'cross-fade',
        color: '#ff0000'
      },
      {
        effect: 'move',
        color: '#00ff00'
      },
      {
        effect: 'zoom',
        color: '#0000ff'
      },
      {
        effect: 'rotation',
        color: '#ffff00'
      },
    ];
    
    const effectRectFactory = (effect) => {
      for (const i in effectRectConfig) {
        if (effect === effectRectConfig[i].effect) {
          const effectRect = draw.rect(1, showBarH)
            .fill(effectRectConfig[i].color).addClass('pkaEffectRect');
          return effectRect;
        }
      }
    };

    // create effectRect
    if (this.picturesData.showEffectColor) {
      const ssi = fm.animationState.stepSliceInfos;
      const fi = fm.animationState.frameInfos;
      for (let i = 0; i < this.picturesData.steps.length; i++) {
        const stepData = this.picturesData.steps[i];
        const effectRect = effectRectFactory(stepData.effect);
        // findout width for every effectRect;
        const startFrameTime = ssi[i].slices[0].time;
        const endFrameTime = ssi[i].slices[ssi[i].slices.length - 1].time;
        let startFrameNum = -1;
        let endFrameNum = fi.length + 1;
        
        // logMsgEnable ? console.log(startFrameTime + ' ' + endFrameTime): null;
        for (let j = 0; j < fi.length; j++) {
          const frame = fi[j];
          if (startFrameTime === ssi[frame.stepNum].slices[0].time && startFrameNum === -1) {
            startFrameNum = j;
          }
          if (startFrameNum !== -1) { // found startFrameNum
            if (endFrameTime === ssi[frame.stepNum].slices[frame.sliceNum].time) {
              endFrameNum = j;
              break;
            }
          }
        }
        const px = 1.0 * startFrameNum / fi.length * this.showBarInfo.width;
        const w = 1.0 * (endFrameNum - startFrameNum) / fi.length * this.showBarInfo.width;
        effectRect.dx(px).width(w);
        
      }
    }
    
  }

  public forwardAnimation() {
    this.pkaPauseContiButton.removeClass('pkaPauseContiButtonPause');
    this.pkaPauseContiButton.removeClass('pkaPauseContiButtonContinue');
    this.pkaPauseContiButton.addClass('pkaPauseContiButtonContinue');
    this.fm.forward();
  }

  public pauseContiAnimation() {
    if (!this.fm.animationState.isRunning) {
      this.pkaPauseContiButton.removeClass('pkaPauseContiButtonPause');
      this.pkaPauseContiButton.removeClass('pkaPauseContiButtonContinue');
      this.pkaPauseContiButton.addClass('pkaPauseContiButtonContinue');
      this.fm.resume();
    } else {
      this.pkaPauseContiButton.removeClass('pkaPauseContiButtonPause');
      this.pkaPauseContiButton.removeClass('pkaPauseContiButtonContinue');
      this.pkaPauseContiButton.addClass('pkaPauseContiButtonPause');
      this.fm.pause();
    }
  }

  public backwardAnimation() {
    this.pkaPauseContiButton.removeClass('pkaPauseContiButtonPause');
    this.pkaPauseContiButton.removeClass('pkaPauseContiButtonContinue');
    this.pkaPauseContiButton.addClass('pkaPauseContiButtonContinue');
    this.fm.backward();
  }

  public waitLoading() {
    if (!this.fm.complete) {
      setTimeout(() => this.waitLoading(), 100);
    } else {
      // init show bar
      this.initShowBar();

      // bind animationState watches
      this.fm.addAnimationStateWatch('currentFrameNumber', (id, oldVal, newVal) => {
        
        const sliceCount = this.fm.animationState.frameInfos.length;
        if (newVal >= 0) {
          const showBarW = this.showBarInfo.width;
          const newW = Math.floor(1.0 * newVal / sliceCount * showBarW);
          this.showBarBar.attr('width', newW);
          
          if (newVal < sliceCount) {
            // step name
            const stepNum = this.fm.animationState.frameInfos[newVal].stepNum;
            if (this.fm.data.steps[stepNum].desc) {
              const stepName = this.fm.data.steps[stepNum].desc;
              this.stepNameSpan.text(stepName);
            }
          }
        }
        if (newVal < 0 || newVal === sliceCount) {
          this.pkaPauseContiButton.removeClass('pkaPauseContiButtonPause');
          this.pkaPauseContiButton.removeClass('pkaPauseContiButtonContinue');
          this.pkaPauseContiButton.addClass('pkaPauseContiButtonPause');
        }
      });

      // show first frame
      this.fm.animationState.currentFrameNumber = 0;

    }
  }
  
  public getPKAnimationFrame() {
    return this.pkaFrame;
  }

  public destroy() {
    $('.pk-footer').removeAttr('style');
    $('#' + this.pkaFrameId).parent().removeAttr('style');
    this.pkaFrame.remove();
  }
}
